module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-offer-blue-2bbdac.svg";